var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsEnum, IsOptional, IsString, ValidateNested } from "class-validator";
import { FeatureScope } from "./feature-enablement.utils";
import { FeatureFlag } from "./features.dtos";
export class FeatureScopeRecordDto {
}
__decorate([
    IsBoolean()
], FeatureScopeRecordDto.prototype, "enabled", void 0);
__decorate([
    IsString(),
    IsOptional()
], FeatureScopeRecordDto.prototype, "configuration", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], FeatureScopeRecordDto.prototype, "updatedAt", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], FeatureScopeRecordDto.prototype, "createdAt", void 0);
__decorate([
    IsOptional(),
    IsString()
], FeatureScopeRecordDto.prototype, "lastUpdatedBy", void 0);
__decorate([
    IsOptional(),
    IsString()
], FeatureScopeRecordDto.prototype, "lastUpdatedByName", void 0);
export class FeatureEnablementItemDto {
}
__decorate([
    IsEnum(FeatureFlag)
], FeatureEnablementItemDto.prototype, "feature", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FeatureScopeRecordDto)
], FeatureEnablementItemDto.prototype, "global", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FeatureScopeRecordDto)
], FeatureEnablementItemDto.prototype, "organization", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FeatureScopeRecordDto)
], FeatureEnablementItemDto.prototype, "patient", void 0);
__decorate([
    IsEnum(FeatureScope)
], FeatureEnablementItemDto.prototype, "resolvedScope", void 0);
__decorate([
    IsBoolean()
], FeatureEnablementItemDto.prototype, "resolvedEnabled", void 0);
__decorate([
    IsOptional(),
    IsDate(),
    Type(() => Date)
], FeatureEnablementItemDto.prototype, "lastUpdatedAt", void 0);
export class FeatureEnablementOverviewDto {
}
__decorate([
    IsOptional(),
    IsString()
], FeatureEnablementOverviewDto.prototype, "organizationId", void 0);
__decorate([
    IsOptional(),
    IsString()
], FeatureEnablementOverviewDto.prototype, "patientId", void 0);
__decorate([
    IsOptional(),
    IsString()
], FeatureEnablementOverviewDto.prototype, "organizationName", void 0);
__decorate([
    IsOptional(),
    IsString()
], FeatureEnablementOverviewDto.prototype, "patientName", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FeatureEnablementItemDto)
], FeatureEnablementOverviewDto.prototype, "features", void 0);
